import { useQuery } from '@tanstack/react-query';
import { getDeals } from '@/lib/api';
import { SEO } from '@/lib/seo';
import { Reveal } from '@/lib/motion';
import ProductCard from '@/components/ProductCard';
import { BUSINESS } from '@/data/site';

export default function Deals() {
  const { data: deals, isLoading } = useQuery({ queryKey: ['deals'], queryFn: getDeals, staleTime: 120000 });

  return (
    <>
      <SEO
        title={`Deals & Bundles | Majestic Greens DMV — Washington, DC`}
        description={`Current cannabis deals, bundles and offers at Majestic Greens DMV, Washington DC. Live from our store catalog. $${BUSINESS.minOrder} minimum order. Adults 21+.`}
        path="/deals"
      />
      <div data-testid="deals-page" className="mx-auto max-w-7xl px-6 pb-28 pt-28">
        <Reveal>
          <p className="text-[11px] font-bold uppercase tracking-[0.4em] text-bronze">Save More</p>
          <h1 className="mt-4 font-serif text-4xl text-ink sm:text-6xl">Deals & bundles</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-sage">
            Current promotions and bundle pricing — pulled live from our store catalog. Deals change, so check back often. ${BUSINESS.minOrder} minimum order applies.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {isLoading
            ? Array.from({ length: 8 }).map((_, i) => <div key={i} className="aspect-[3/4] animate-pulse border border-ink/5 bg-surface" />)
            : (deals || []).map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>

        {!isLoading && deals && deals.length === 0 && (
          <div data-testid="deals-empty-state" className="border border-ink/10 py-20 text-center">
            <p className="font-serif text-2xl text-sage">No active deals right now</p>
            <p className="mt-2 text-sm text-ash">Call {BUSINESS.phone} to ask about current promotions.</p>
          </div>
        )}
      </div>
    </>
  );
}
